import { useQuery } from "@tanstack/react-query";
import { api } from "../../api";
import type { Period } from "../../generated/core-api";

export function useMcpInteractionTimeseries(
  fromDate: string,
  toDate: string,
  period: Period,
) {
  return useQuery({
    queryKey: [
      "platformAnalytics",
      "mcpInteractionTimeseries",
      fromDate,
      toDate,
      period,
    ],
    queryFn: () =>
      api.getMcpInteractionTimeseries({
        from_date: fromDate,
        to_date: toDate,
        period,
      }),
  });
}
